export const BASE_URL = 'features/modules/emerald';
